import * as React from "react"
import styled from "styled-components"

import { Color, RadiusSize, Shadow, SpacingSize, TextSize } from "~/consts/style-mixins"

interface Props {
  items: item[]
}

interface item {
  name: string
  href: string
  linkClassName?: string
}

const BalloonMenu = ({ items }: Props) => {
  return (
    <StyledBalloonMenu>
      {items.map((item: item, index) => {
        return (
          <li key={index}>
            <StyledBalloonMenuItem href={item.href} className={item.linkClassName}>
              {item.name}
            </StyledBalloonMenuItem>
          </li>
        )
      })}
    </StyledBalloonMenu>
  )
}

const StyledBalloonMenu = styled.ul`
  position: relative;
  background: ${Color.White};
  border-radius: ${RadiusSize.Medium}px;
  padding: ${SpacingSize.S}px 0;
  ${Shadow.Shallow};
  &:before {
    display: inline-block;
    position: absolute;
    top: -8px;
    left: calc(50% - 11px);
    content: "";
    width: 16px;
    height: 16px;
    background: ${Color.White};
    transform: rotate(45deg);
    ${Shadow.Shallow};
  }
  &:after {
    display: block;
    position: absolute;
    top: 0;
    content: "";
    width: 100%;
    height: 12px;
    background: ${Color.White};
    border-radius: ${RadiusSize.Medium}px;
  }
`

const StyledBalloonMenuItem = styled.a`
  display: block;
  color: ${Color.Gray};
  font-size: ${TextSize.S}px;
  font-weight: bold;
  padding: ${SpacingSize.S}px ${SpacingSize.M}px;
  &:hover {
    background: ${Color.BackgroundGray};
  }
`

export default BalloonMenu
